export const END_POINT = '/api/v1/fluentform/submit'
